import LabelPrimary from './LabelPrimary';

export default LabelPrimary;
